'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import { QueryClient, QueryClientProvider, type DefaultOptions } from '@tanstack/react-query';
interface QueryProviderProps {
  children: React.ReactNode;
  /**
   * Per-app overrides merged over the shared defaults. Use this rather than forking
   * the provider so both frontends keep the same retry/error behaviour by default.
   */
  defaultOptions?: DefaultOptions;
}
export function QueryProvider(t0) {
  const $ = _c(5);
  const {
    children,
    defaultOptions
  } = t0;
  let t1;
  if ($[0] !== defaultOptions) {
    t1 = () => new QueryClient({
      defaultOptions: {
        ...defaultOptions,
        queries: {
          staleTime: 10000,
          retry: _temp,
          refetchOnWindowFocus: false,
          ...defaultOptions?.queries
        },
        mutations: {
          retry: false,
          ...defaultOptions?.mutations
        }
      }
    });
    $[0] = defaultOptions;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [queryClient] = useState(t1);
  let t2;
  if ($[2] !== children || $[3] !== queryClient) {
    t2 = <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
    $[2] = children;
    $[3] = queryClient;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
function _temp(failureCount, error) {
  if (error && typeof error === "object" && "response" in error) {
    const response = (error as {
      response: {
        status: number;
      };
    }).response;
    if (response?.status >= 400 && response?.status < 500) {
      return false;
    }
  }
  return failureCount < 3;
}